import * as THREE from 'three'
import * as dat from 'dat.gui'
import ForestConfig from './ForestConfig'
import { createLights } from './elements/lights'
import { createParticles, updateParticles } from './elements/particles'
import { createTrees } from './elements/trees'
import { createBunny, addBunnyGui } from './elements/bunny'
import { Controls, initControls, stopControls } from './Controls'

const initForest = (onComplete) => {
  let forestActive = true
  const OnComplete = () => {
    canvas.classList.add('hidden')
    window.removeEventListener('resize', resizeForest)
    stopControls()
    onComplete()
  }

  const gamePropmt = document.querySelector('.forest-game-prompt')
  const gamePropmtText = document.querySelector('.forest-game-prompt__text')

  /**
   * Dat gui
   */
  const gui = new dat.GUI()
  gui.hide()

  const config = ForestConfig

  /**
   * Base
   */
  // Canvas
  const canvas = document.querySelector('canvas.webgl')

  // Scene
  const scene = new THREE.Scene()
  scene.fog = new THREE.Fog('black', 10, 100);

  /**
   * Lights
   */
  const lights = createLights(scene, gui)

  /**
   * Object
   */

  //-----floor ------///

  const floorGeometry = new THREE.PlaneGeometry(2000, 2000)
  const floorMaterial = new THREE.MeshStandardMaterial({color: 'green'})
  const floorMesh = new THREE.Mesh(floorGeometry, floorMaterial)
  floorMesh.position.y = -1
  floorMesh.rotation.x = Math.PI * -0.5
  scene.add(floorMesh)

  // ----- Bunny --------//

  const player = createBunny(scene, gui)
  addBunnyGui(scene, gui)

  // ----- TREES ---------//
  createTrees(scene, gui)
  //addGuiToTrees(scene, gui)

  // ----- PARTICLES ------- //
  //Geometry
  const startParticles = createParticles(scene)
  startParticles.position.z = -20
  startParticles.position.y = 0
  //addGuiToParticles(scene, gui)

  const exitParticles = createParticles(scene, 'red')
  const exitParticlesAngle = Math.random() * Math.PI * 2
  const exitParticlesDist = config.exit.dist
  exitParticles.position.z = Math.sin(exitParticlesAngle) * exitParticlesDist
  exitParticles.position.x = Math.cos(exitParticlesAngle) * exitParticlesDist
  exitParticles.position.y = 0

  /**
   * Sizes
   */
  const sizes = {
      width: window.innerWidth,
      height: window.innerHeight
  }

  const resizeForest = () =>
  {
      // Update sizes
      sizes.width = window.innerWidth
      sizes.height = window.innerHeight

      // Update camera
      camera.aspect = sizes.width / sizes.height
      camera.updateProjectionMatrix()

      // Update renderer
      renderer.setSize(sizes.width, sizes.height)
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  }

  window.addEventListener('resize', resizeForest)

  /**
   * Camera
   */
  // Base camera
  const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
  camera.position.z = config.camera.zDist
  camera.position.y = 10
  scene.add(camera)

  /**
   * Controls
   */

  const controls = Controls
  initControls()

  /**
   * Renderer
   */
  const renderer = new THREE.WebGLRenderer({
      canvas: canvas
  })
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

  /**
   * Animate
   */
  const clock = new THREE.Clock()

  let lastElapsed = null
  let lastTick = null

  player.rotation.y = Math.PI
  let cameraRotation = 0
  let promptVisible = false

  let foundGear = false

  const tick = () =>
  {
      const elapsedTime = clock.getElapsedTime()
      if (lastElapsed === null) lastElapsed = elapsedTime
      lastTick = elapsedTime - lastElapsed
      lastElapsed = elapsedTime
      // Update Particles
      updateParticles(startParticles)
      updateParticles(exitParticles)

      if (!foundGear) {
        if (controls.isDown) {
          lights.position.x = player.position.x -= Math.sin(player.rotation.y) * (config.bunny.speed * lastTick)
          lights.position.z = player.position.z -= Math.cos(player.rotation.y) * (config.bunny.speed * lastTick)
        }
  
        if (controls.isUp) {
          lights.position.x = player.position.x += Math.sin(player.rotation.y) * (config.bunny.speed * lastTick)
          lights.position.z = player.position.z += Math.cos(player.rotation.y) * (config.bunny.speed * lastTick)
        }
  
        if (controls.isLeft) {
          player.rotation.y += config.bunny.angularSpeed * lastTick
        }
  
        if (controls.isRight) {
          player.rotation.y -= config.bunny.angularSpeed * lastTick
        }
  
        if (cameraRotation < player.rotation.y - (config.camera.angularSpeed * 3)) {
          cameraRotation += config.camera.angularSpeed
        } else if (cameraRotation > player.rotation.y + (config.camera.angularSpeed * 3)) {
          cameraRotation -= config.camera.angularSpeed
        }
  
        camera.position.x = player.position.x - Math.sin(cameraRotation) * config.camera.zDist
        camera.position.z = player.position.z - Math.cos(cameraRotation) * config.camera.zDist 
      } else {
        camera.position.x = player.position.x - Math.sin(elapsedTime) * config.camera.zDist
        camera.position.z = player.position.z - Math.cos(elapsedTime) * config.camera.zDist 
      }

      camera.lookAt(player.position)

      const now = new Date()


      // check colision with first particles
      if (player.position.distanceTo(startParticles.position) < 10) {
        if (!promptVisible) {
          promptVisible = true
          if (gamePropmt.classList.contains('hidden')) gamePropmt.classList.remove('hidden')
          gamePropmtText.innerHTML = 'With your red eyes, find the red exit.'
        }
      } else {
        if (promptVisible) {
          promptVisible = false
          if (!gamePropmt.classList.contains('hidden')) gamePropmt.classList.add('hidden')
        }
      }

      // check colision with final particles
      if (player.position.distanceTo(exitParticles.position) < 10) {
        gamePropmtText.innerHTML = 'You have found climbing gear.'
        if (gamePropmt.classList.contains('hidden')) gamePropmt.classList.remove('hidden')

        foundGear = true

        setTimeout(() => {
          if (!gamePropmt.classList.contains('hidden')) gamePropmt.classList.add('hidden')
          forestActive = false
          OnComplete() 
        }, 5000)
      }

      // Render
      renderer.render(scene, camera)

      // Call tick again on the next frame
      if (forestActive) window.requestAnimationFrame(tick)
  }

  tick()
}

export {
  initForest
}